import debounce from "lodash/debounce";
import { KeyRound } from "lucide-react";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  Badge,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Spinner,
  UncontrolledDropdown,
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableItem,
  DataTableRow,
  Icon,
  PaginationComponent,
  TooltipComponent,
} from "../../components/Component";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import AddUserModal from "./AddUser";
import DeleteModal from "./DeleteModal";
import EditUserModal from "./EditUser";
import { listUsers, updatedStatus } from "../../api/user";
import UserPasswordChange from "./UserPasswordChange";
import CustomTooltip from "../../components/tooltip/CustomTooltip.js";
const UserListRegularPage = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  // const [sm, updateSm] = useState(false);
  const sm = false;
  // const [tablesm, updateTableSm] = useState(false);
  const tablesm = false;
  const [onSearch, setonSearch] = useState(true);
  const [onSearchText, setSearchText] = useState("");
  // const [actionText, setActionText] = useState("");
  const actionText = "";
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(10);
  const [sort, setSortState] = useState("asc");
  const [sortType, setSortType] = useState("DESC");
  const [modal, setModal] = useState(false);
  const [addUserModal, setAddUserModal] = useState(false);
  const [editUserModal, setEditUserModal] = useState(false);
  const [resetPasswordModal, setResetPasswordModal] = useState(false);
  const [mutation, setMutation] = useState({});
  const [userDataForEdit, setUserDataForEdit] = useState({
    id: "",
    name: "",
    email: "",
    setMutationCall: () => {
      setMutation({});
    },
  });
  const [DeleteDetails, setDeleteDetails] = useState({
    id: null,
  });
  const [resetPasswordDetails, setResetPasswordDetails] = useState({
    id: null,
  });

  useEffect(() => {
    // Create a debounced function for fetching the user list
    setLoading(true);
    const debouncedHandleUserList = debounce(async () => {
      try {
        const response = await listUsers({
          search: onSearchText,
          order: sortType,
          page: currentPage,
          limit: itemPerPage,
        });
        setData(response.data.data.userData);
      } catch (error) {
        console.error(error);
        toast.error(error?.response?.data?.message);
      } finally {
        setLoading(false);
      }
    }, 300); // Delay of 300ms

    // Execute the debounced function
    debouncedHandleUserList();

    // Cleanup function to cancel the debounce if the component unmounts
    return () => {
      debouncedHandleUserList.cancel();
    };
  }, [currentPage, itemPerPage, sortType, onSearchText, mutation, actionText]);

  const handelModal = (value) => {
    setModal(value);
  };
  const handleDelete = (id) => {
    try {
      setModal(true);
      setDeleteDetails({
        id: id,
      });
    } catch (error) {
      console.error(error);
    }
  };
  const handleResetPassword = (id) => {
    try {
      setResetPasswordModal(true);
      setResetPasswordDetails({
        id: id,
      });
    } catch (error) {
      console.error(error);
    }
  };
  const handleAddUser = (value) => {
    setAddUserModal(value);
  };
  const handleEditUser = (value) => {
    setEditUserModal(value);
  };
  const handleResetPasswordUser = (value) => {
    setResetPasswordModal(value);
  };

  // Sorting data
  const sortFunc = (params) => {
    if (params === "asc") {
      setSortType("ASC");
    } else if (params === "dsc") {
      setSortType("DESC");
    }
  };

  // onChange function for searching name
  const onFilterChange = (e) => {
    setSearchText(e.target.value);
  };

  // function which fires on applying selected action
  const onActionClick = (e) => {
    if (actionText === "suspend") {
      let newData = data.map((item) => {
        if (item.checked === true) item.status = "Suspend";
        return item;
      });
      setData([...newData]);
    } else if (actionText === "delete") {
      let newData;
      newData = data.filter((item) => item.checked !== true);
      setData([...newData]);
    }
  };

  // function to toggle the search option
  const toggle = () => setonSearch(!onSearch);

  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleStatus = async (updateStatus, id) => {
    try {
      const response = await updatedStatus(updateStatus, id);
      toast.success(response?.data?.message, {
        position: "top-center",
      });
      setMutation({});
    } catch (error) {
      console.error("Error:", error);
      toast.error(error?.response?.data?.message, {
        position: "top-center",
      });
    }
  };

  return (
    <React.Fragment>
      <Head title="Manage Users"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle tag="h3" page>
                Users List
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <Button
                  color="primary"
                  className={`btn-icon  ${sm ? "active" : ""}`}
                  onClick={() => {
                    handleAddUser(true);
                  }}
                >
                  <Icon name="plus"></Icon>
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block className="px-2 px-md-0">
          <DataTable className="card-stretch">
            <div className="card-inner position-relative card-tools-toggle">
              <div className="card-title-group">
                <div className="card-tools">
                  <div className="form-inline flex-nowrap gx-3">
                    <div className="btn-wrap">
                      <span className="d-none">
                        <Button
                          color="light"
                          outline
                          disabled={actionText !== "" ? false : true}
                          className="btn-dim btn-icon"
                          onClick={(e) => onActionClick(e)}
                        >
                          <Icon name="arrow-right"></Icon>
                        </Button>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="card-tools me-n1">
                  <ul className="btn-toolbar gx-1">
                    <li>
                      <a
                        href="#search"
                        onClick={(ev) => {
                          ev.preventDefault();
                          toggle();
                        }}
                        className="btn btn-icon search-toggle toggle-search"
                      >
                        <Icon name="search"></Icon>
                      </a>
                    </li>
                    <li className="btn-toolbar-sep"></li>
                    <li>
                      <div className="toggle-wrap">
                        <UncontrolledDropdown>
                          <DropdownToggle
                            color="tranparent"
                            className={`btn btn-trigger btn-icon dropdown-toggle ${
                              tablesm ? "active" : ""
                            }`}
                          >
                            <Icon name="setting"></Icon>
                          </DropdownToggle>
                          <DropdownMenu end className="dropdown-menu-xs">
                            <ul className="link-check">
                              <li>
                                <span>Show</span>
                              </li>
                              <li
                                className={itemPerPage === 10 ? "active" : ""}
                              >
                                <DropdownItem
                                  tag="a"
                                  href="#dropdownitem"
                                  onClick={(ev) => {
                                    ev.preventDefault();
                                    setItemPerPage(10);
                                  }}
                                >
                                  10
                                </DropdownItem>
                              </li>
                              <li
                                className={itemPerPage === 20 ? "active" : ""}
                              >
                                <DropdownItem
                                  tag="a"
                                  href="#dropdownitem"
                                  onClick={(ev) => {
                                    ev.preventDefault();
                                    setItemPerPage(20);
                                  }}
                                >
                                  20
                                </DropdownItem>
                              </li>
                              <li
                                className={itemPerPage === 50 ? "active" : ""}
                              >
                                <DropdownItem
                                  tag="a"
                                  href="#dropdownitem"
                                  onClick={(ev) => {
                                    ev.preventDefault();
                                    setItemPerPage(50);
                                  }}
                                >
                                  50
                                </DropdownItem>
                              </li>
                            </ul>
                            <ul className="link-check">
                              <li>
                                <span>Order</span>
                              </li>
                              <li className={sort === "dsc" ? "active" : ""}>
                                <DropdownItem
                                  tag="a"
                                  href="#dropdownitem"
                                  onClick={(ev) => {
                                    ev.preventDefault();
                                    setSortState("dsc");
                                    sortFunc("dsc");
                                  }}
                                >
                                  DESC
                                </DropdownItem>
                              </li>
                              <li className={sort === "asc" ? "active" : ""}>
                                <DropdownItem
                                  tag="a"
                                  href="#dropdownitem"
                                  onClick={(ev) => {
                                    ev.preventDefault();
                                    setSortState("asc");
                                    sortFunc("asc");
                                  }}
                                >
                                  ASC
                                </DropdownItem>
                              </li>
                            </ul>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div
                className={`card-search search-wrap ${!onSearch && "active"}`}
              >
                <div className="card-body">
                  <div className="search-content">
                    <Button
                      className="search-back btn-icon toggle-search active"
                      onClick={() => {
                        setSearchText("");
                        toggle();
                      }}
                    >
                      <Icon name="arrow-left"></Icon>
                    </Button>
                    <input
                      type="text"
                      className="border-transparent form-focus-none form-control"
                      placeholder="Search by name or email"
                      value={onSearchText}
                      onChange={(e) => onFilterChange(e)}
                    />
                    <Button className="search-submit btn-icon">
                      <Icon name="search"></Icon>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <DataTableBody>
              <DataTableHead>
                <DataTableRow size="md">
                  <span className="sub-text d-none d-md-block">Name</span>
                </DataTableRow>
                <DataTableRow size="md">
                  <span className="sub-text">Email</span>
                </DataTableRow>
                <DataTableRow size="md">
                  <span className="sub-text">Status</span>
                </DataTableRow>
                <DataTableRow size="md">
                  <span className="sub-text">Role</span>
                </DataTableRow>
                <DataTableRow size="md">
                  <span className="sub-text">Created At</span>
                </DataTableRow>
                <DataTableRow
                  className="nk-tb-col-tools text-end"
                  size="md"
                ></DataTableRow>
              </DataTableHead>
              {loading ? (
                <tr>
                  <td colSpan="100%">
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "100px", width: "100%" }} // Full height and width
                    >
                      <Spinner color="primary" />
                    </div>
                  </td>
                </tr>
              ) : (
                <>
                  {/*Head*/}
                  {currentItems?.length > 0
                    ? currentItems?.map((item) => {
                        return (
                          <React.Fragment key={item.id}>
                            <DataTableItem>
                              <DataTableRow size="md">
                                <div
                                  className="d-flex align-items-center gap-2"
                                  style={{
                                    cursor: "pointer",
                                  }}
                                >
                                  <div className="user-avatar user-avatar-sm bg-primary-dim">
                                    <span className="text-uppercase">
                                      {item?.name[0]}
                                    </span>
                                  </div>
                                  <div>
                                    <div>{item.name}</div>
                                    <div className="fs-11px d-md-none">
                                      {item.email}
                                    </div>
                                  </div>
                                </div>
                              </DataTableRow>

                              <DataTableRow size="md">
                                <span>{item.email}</span>
                              </DataTableRow>

                              <DataTableRow size="md">
                                <span
                                  className={`tb-status text-${
                                    item.status === "active"
                                      ? "success"
                                      : "danger"
                                  }`}
                                >
                                  {item.status === "active"
                                    ? "Active"
                                    : "Inactive"}
                                </span>
                              </DataTableRow>
                              <DataTableRow size="md">
                                <Badge
                                  pill
                                  color={
                                    item.role === "admin"
                                      ? "primary"
                                      : "secondary"
                                  }
                                  className="text-uppercase"
                                >
                                  {item.role}
                                </Badge>
                              </DataTableRow>
                              <DataTableRow size="md">
                                <span>
                                  {moment(item.createdAt).format("MM-DD-YYYY")}
                                </span>
                              </DataTableRow>
                              <DataTableRow
                                size="md"
                                className="nk-tb-col-tools"
                              >
                                <ul className="nk-tb-actions gx-1">
                                  <li
                                    className="nk-tb-action-hidden d-block d-md-none"
                                    onClick={() => {
                                      handleEditUser(true);
                                      setUserDataForEdit({
                                        id: item.id,
                                        name: item.name,
                                        email: item.email,
                                        role: item.role,
                                        setMutationCall: () => {
                                          setMutation({});
                                        },
                                      });
                                    }}
                                  >
                                    <TooltipComponent
                                      tag="a"
                                      containerClassName="btn btn-trigger btn-icon"
                                      id={"edit" + item.id}
                                      icon="edit"
                                      direction="top"
                                      text="Edit"
                                    />
                                  </li>
                                  <li
                                    className="nk-tb-action-hidden d-block d-md-none"
                                    onClick={(ev) => {
                                      handleResetPasswordUser(true);
                                      handleResetPassword(item.id);
                                    }}
                                  >
                                    <CustomTooltip
                                      tag="a"
                                      containerClassName="btn btn-trigger btn-icon"
                                      id={"account-setting" + item.id}
                                      text={"Reset Password"}
                                      icon="account-setting"
                                      direction="top"
                                    ></CustomTooltip>
                                  </li>
                                  <li>
                                    <UncontrolledDropdown>
                                      <DropdownToggle
                                        tag="a"
                                        className="dropdown-toggle btn btn-icon btn-trigger"
                                      >
                                        <Icon name="more-h"></Icon>
                                      </DropdownToggle>
                                      <DropdownMenu end>
                                        <ul className="link-list-opt no-bdr">
                                          <li
                                            onClick={() => {
                                              handleEditUser(true);
                                              setUserDataForEdit({
                                                id: item.id,
                                                name: item.name,
                                                email: item.email,
                                                role: item.role,
                                                setMutationCall: () => {
                                                  setMutation({});
                                                },
                                              });
                                            }}
                                          >
                                            <DropdownItem
                                              tag="a"
                                              href="#edit"
                                              onClick={(ev) => {
                                                handleEditUser(true);
                                                setUserDataForEdit({
                                                  id: item.id,
                                                  name: item.name,
                                                  email: item.email,
                                                  role: item.role,
                                                  setMutationCall: () => {
                                                    setMutation({});
                                                  },
                                                });
                                              }}
                                            >
                                              <Icon name="edit"></Icon>
                                              <span>Edit User</span>
                                            </DropdownItem>
                                          </li>
                                          <li onClick={() => {}}>
                                            <DropdownItem
                                              tag="a"
                                              href="#trash"
                                              onClick={(ev) => {
                                                handleResetPasswordUser(true);
                                                handleResetPassword(item.id);
                                              }}
                                            >
                                              <KeyRound size={16} />

                                              <span className="ps-3">
                                                Reset Password
                                              </span>
                                            </DropdownItem>
                                          </li>
                                          <li onClick={() => {}}>
                                            <DropdownItem
                                              tag="a"
                                              href="#trash"
                                              onClick={(ev) => {
                                                handleStatus(
                                                  item.status === "active"
                                                    ? "Inactive"
                                                    : "Active",
                                                  item.id
                                                );
                                              }}
                                            >
                                              <Icon
                                                name={`${
                                                  item.status === "active"
                                                    ? "cross"
                                                    : "check"
                                                }`}
                                              ></Icon>
                                              <span>
                                                {item.status === "active"
                                                  ? "Inactive"
                                                  : "Active"}
                                              </span>
                                            </DropdownItem>
                                          </li>

                                          <li onClick={() => {}}>
                                            <DropdownItem
                                              tag="a"
                                              href="#trash"
                                              onClick={(ev) => {
                                                handleDelete(item.id);
                                              }}
                                            >
                                              <Icon
                                                name="trash"
                                                className="text-danger"
                                              ></Icon>
                                              <span className="text-danger">
                                                Delete User
                                              </span>
                                            </DropdownItem>
                                          </li>
                                        </ul>
                                      </DropdownMenu>
                                    </UncontrolledDropdown>
                                  </li>
                                </ul>
                              </DataTableRow>
                            </DataTableItem>
                            {
                              <div className="d-md-none nk-tb-item">
                                <div className="nk-tb-col tb-col-xs">
                                  <div className="d-flex g-1 align-items-center">
                                    <div className="user-avatar user-avatar-lg bg-primary-dim me-3">
                                      <span className="text-uppercase p-2">
                                        {item?.name[0]}
                                      </span>
                                    </div>
                                    <div>
                                      <div className="fs-16px">
                                        {item?.name}
                                      </div>
                                      <div className="sub-text d-md-none fs-15px">
                                        {item?.email}
                                      </div>
                                      <div className="sub-text d-md-none fs-13px">
                                        <span>Role: &nbsp;</span>{" "}
                                        <Badge
                                          pill
                                          color={
                                            item.role === "admin"
                                              ? "primary"
                                              : "secondary"
                                          }
                                          className="text-uppercase"
                                          style={{
                                            fontSize: "8px",
                                            padding: "2px 4px",
                                            lineHeight: "1",
                                          }}
                                        >
                                          {item.role}
                                        </Badge>
                                      </div>
                                      <div className="sub-text fs-13px">
                                        <span>Status: &nbsp;</span>{" "}
                                        <span
                                          className={`  text-${
                                            item.status === "active"
                                              ? "success"
                                              : "danger"
                                          }`}
                                        >
                                          {item.status === "active"
                                            ? "Active"
                                            : "Inactive"}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="nk-tb-col tb-col-xs">
                                  <ul className="nk-tb-actions gx-1">
                                    <li>
                                      <UncontrolledDropdown>
                                        <DropdownToggle
                                          tag="a"
                                          className="dropdown-toggle btn btn-icon btn-trigger"
                                        >
                                          <Icon name="more-h"></Icon>
                                        </DropdownToggle>
                                        <DropdownMenu end>
                                          <ul className="link-list-opt no-bdr">
                                            <li
                                              onClick={() => {
                                                handleEditUser(true);
                                                setUserDataForEdit({
                                                  id: item.id,
                                                  name: item.name,
                                                  email: item.email,
                                                  role: item.role,
                                                  setMutationCall: () => {
                                                    setMutation({});
                                                  },
                                                });
                                              }}
                                            >
                                              <DropdownItem
                                                tag="a"
                                                href="#edit"
                                                onClick={(ev) => {
                                                  handleEditUser(true);
                                                  setUserDataForEdit({
                                                    id: item.id,
                                                    name: item.name,
                                                    email: item.email,
                                                    role: item.role,
                                                    setMutationCall: () => {
                                                      setMutation({});
                                                    },
                                                  });
                                                }}
                                              >
                                                <Icon name="edit"></Icon>
                                                <span>Edit User</span>
                                              </DropdownItem>
                                            </li>

                                            <li onClick={() => {}}>
                                              <DropdownItem
                                                tag="a"
                                                href="#trash"
                                                onClick={(ev) => {
                                                  handleResetPasswordUser(true);
                                                  handleResetPassword(item.id);
                                                }}
                                              >
                                                <KeyRound size={16} />

                                                <span className="ps-3">
                                                  Reset Password
                                                </span>
                                              </DropdownItem>
                                            </li>
                                            <li onClick={() => {}}>
                                              <DropdownItem
                                                tag="a"
                                                href="#trash"
                                                onClick={(ev) => {
                                                  handleStatus(
                                                    item.status === "active"
                                                      ? "Inactive"
                                                      : "Active",
                                                    item.id
                                                  );
                                                }}
                                              >
                                                <Icon
                                                  name={`${
                                                    item.status === "active"
                                                      ? "cross"
                                                      : "check"
                                                  }`}
                                                ></Icon>
                                                <span>
                                                  {item.status === "active"
                                                    ? "Inactive"
                                                    : "Active"}
                                                </span>
                                              </DropdownItem>
                                            </li>
                                            <li onClick={() => {}}>
                                              <DropdownItem
                                                tag="a"
                                                href="#trash"
                                                onClick={(ev) => {
                                                  handleDelete(item.id);
                                                }}
                                              >
                                                <Icon
                                                  name="trash"
                                                  className="text-danger"
                                                ></Icon>
                                                <span className=" text-danger">
                                                  Delete User
                                                </span>
                                              </DropdownItem>
                                            </li>
                                          </ul>
                                        </DropdownMenu>
                                      </UncontrolledDropdown>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            }
                          </React.Fragment>
                        );
                      })
                    : null}
                </>
              )}
            </DataTableBody>
            <div className="card-inner">
              {currentItems.length > 0 ? (
                <PaginationComponent
                  itemPerPage={itemPerPage}
                  totalItems={data.length}
                  paginate={paginate}
                  currentPage={currentPage}
                />
              ) : (
                <div className="text-center">
                  <span className="text-silent">No data found</span>
                </div>
              )}
            </div>
          </DataTable>
        </Block>
      </Content>
      <DeleteModal
        handelModal={handelModal}
        DeleteDetails={DeleteDetails}
        modal={modal}
        mutation={userDataForEdit.setMutationCall}
      />
      <AddUserModal
        modalForm={addUserModal}
        setModalForm={handleAddUser}
        mutation={userDataForEdit.setMutationCall}
      />
      <EditUserModal
        modalForm={editUserModal}
        setModalForm={handleEditUser}
        userData={userDataForEdit}
      />
      <UserPasswordChange
        modalForm={resetPasswordModal}
        setModalForm={handleResetPasswordUser}
        userData={resetPasswordDetails}
      />
    </React.Fragment>
  );
};
export default UserListRegularPage;
